import React from 'react';

/**
 * MarqueeRow — infinite horizontal scroll of children. The content is rendered
 * twice in a row and animated with CSS @keyframes so it loops seamlessly.
 *
 * Props:
 *  - speed: seconds for one loop (default 28)
 *  - reverse: scroll right-to-left when false, left-to-right when true
 */
const MarqueeRow = ({ children, speed = 28, reverse = false, className = '' }) => {
  return (
    <div className={`overflow-hidden relative ${className}`} aria-hidden="true">
      <div
        className="flex gap-10 whitespace-nowrap"
        style={{
          animation: `${reverse ? 'marquee-reverse' : 'marquee'} ${speed}s linear infinite`,
          width: 'max-content',
        }}
      >
        {children}
        {children}
      </div>
    </div>
  );
};

export default MarqueeRow;
